import React, { useState, Fragment,useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { CloseIcon } from "../../utils/common/icon-hooks.js";
import FCInputSearchField from "../../utils/library/textboxsearch";
import FCButtonWithClick from "../../utils/library/buttonwithclick";

const MultiFilter = ({ options, selectedIds, isOpen, multiFilterClose, handleSearchSite, handleSearchPlan, handleSearchUsers, handleMultiFilter, handleMultiFilterApply, type,
	handleClearMultiFilter, handleFilterSelectAll, handleDeSelectAll }) => {
	const [searchSiteText, setSearchSiteText] = useState("");
	const [searchPlanText, setSearchPlanText] = useState("");
	const [searchUserText, setSearchUserText] = useState("");

	const handleFilterSearch = (searchTxt) => {
		if (type == 'site') {
			setSearchSiteText(searchTxt)
			handleSearchSite(searchTxt, type);
		}
		if (type == 'samplePlan') {
			setSearchPlanText(searchTxt)
			handleSearchPlan(searchTxt, type);
		}
		if (type == 'users') {
			setSearchUserText(searchTxt);
			handleSearchUsers(searchTxt, type);
		}

	}
	const handleFilterClose = () => {
		multiFilterClose();
	}
	const handleFilterSelect = (event) => {
		handleMultiFilter(event,type)
	}
	const handleMultiSelectAll = () => {
		handleFilterSelectAll(type)
	}
	const handleMultiDeSelectAll = () => {
		handleDeSelectAll(type)
	}
	const handleApplyFilter = () => {
		handleMultiFilterApply(type)
	}
	const handleFilterClear = () => {
		handleClearMultiFilter(type)
	}
	useEffect(() => {
		setSearchSiteText("")
	}, [options]);
	return (
		<Transition.Root show={isOpen} as={Fragment}>
			<Dialog
				as="div"
				className="fixed z-10 inset-0 overflow-y-auto"
				onClose={() =>(handleFilterClose)}
			>
				<div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0"
						enterTo="opacity-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100"
						leaveTo="opacity-0"
					>
						<Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
					</Transition.Child>

					{/* This element is to trick the browser into centering the modal contents. */}
					<span
						className="hidden sm:inline-block sm:align-middle sm:h-screen"
						aria-hidden="true"
					>
						&#8203;
					</span>
					<Transition.Child
						as={Fragment}
						enter="ease-out duration-300"
						enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						enterTo="opacity-100 translate-y-0 sm:scale-100"
						leave="ease-in duration-200"
						leaveFrom="opacity-100 translate-y-0 sm:scale-100"
						leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
					>
						<div className="inline-block w-1/2 align-bottom bg-white font-large rounded-2xl px-4 pt-5 pb-4 text-left transform transition-all sm:align-middle sm:px-10">
							<div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
								<button
									type="button"
									className="bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
									onClick={() => handleFilterClose()}
								>
									<span className="sr-only">Close</span>
									<CloseIcon />
								</button>
							</div>
							<div className="sm:flex sm:items-start">
								<div className="mt-3 text-left sm:mt-0 sm:ml-4 sm:text-left w-full mb-5">
									<Dialog.Title
										as="h3"
										className="text-lg leading-6  text-gray-500"
									>
										{`Select ${type}`}
									</Dialog.Title>
								</div>
							</div>
							<form>
								<div className="flex">
									<div className="pl-7 pr-8 ">
										<FCInputSearchField
											placeholder={`Search ${type }`}
											id="search"
											onChange={(value) => { handleFilterSearch(value) }}
											value={type == 'site' ? searchSiteText : type == 'samplePlan' ? searchPlanText : searchUserText}
										/>
									</div>
									<div className="ml-auto flex gap-4 pr-8">
										<button
											type ="button"
											className="text-blue-600 hover:underline"
											onClick={handleMultiSelectAll}
										>
											Select All
										</button>
										<button
											type="button"
											className="text-blue-600 hover:underline"
											onClick={handleMultiDeSelectAll} 
										>
											Deselect All
										</button>
									</div>
								</div>
								<div>&nbsp;</div>
								{/*<div className={"mb-3 mx-auto "}>*/}
									{/*{label && <label className="flex flex-row text-gray-500">{label}</label>}*/}
								<div className="mb-3 pl-7 pr-8">
									{options && options.length === 0 && (
										<h2>No Data Found.</h2>
									)}

									{options && options.length > 0 && (
										<div className="grid grid-cols-3 gap-x-2 gap-y-3">
											{options
												.filter(item => item.value !== 0)
												.map((item) => (
													<label
														key={"keydiv" + item.value}
														htmlFor={item.value?.toString() || ""}
														className="flex items-center space-x-1"
													>
														<input
															id={item.value?.toString() || ""}
															type="checkbox"
															value={item.value}
															checked={selectedIds.includes(item.value?.toString() || "")}
															onChange={handleFilterSelect}
															className="h-4 w-4 border-2 border-gray-300 rounded"
														/>
														<span className="text-sm text-blue-900 break-words">
															{item.label}
														</span>
													</label>
												))}
										</div>
									)}
								</div>
								{/*</div>*/}
								<div>&nbsp;</div>
								<div className="pb-5 sm:items-center">
									<div className="mt-3 flex sm:mt-0">
										<div className="w-3/5 align-middle flex">
											<div className="w-1/3">&nbsp;</div>
											{/*<div className="w-1/3 align-middle">*/}
											{/*	<FCButtonWithClick*/}
											{/*		onHandleClick={handleFilterClear}*/}
											{/*		bgColor="bg-fcbutton mr-3"*/}
											{/*		type="button"*/}
											{/*		icon=""*/}
											{/*		value="Clear"*/}
											{/*	/>*/}
											{/*</div>*/}
											{/*<div className="w-1/3">&nbsp;</div>*/}
										</div>
										<div className="w-1/5 align-top">
											<FCButtonWithClick
												onHandleClick={handleFilterClose}
												bgColor="bg-fcbutton mr-3"
												type="button"
												icon=""
												value="Cancel"
											/>
										</div>
										<div className="w-1/5 align-top">
											<FCButtonWithClick
												bgColor="bg-primary mr-3"
												type="button"
												onHandleClick={handleApplyFilter}
												icon=""
												value="Apply"
											/>
										</div>
									</div>
								</div>
							</form>
						</div>
					</Transition.Child>
				</div>
			</Dialog>
		</Transition.Root>
	)

}
export default MultiFilter